import React from "react";

const QatarPccProcedure = () => {
  return (
    <div className="pccExpContainer">
      <h2>
        Procedure for Qatar<span> PCC</span> Verification in Bangalore{" "}
      </h2>
      <p>
        The process of Qatar PCC verification consists of several crucial steps
        managed by Goodway Attestation Services:
      </p>
      <ul>
        <li>
          <h3>
            <span>1.</span> Application Submission:
          </h3>{" "}
          The applicant submits the PCC application along with supporting
          documents to the local police department or relevant authority.
        </li>
        <li>
          <h3>
            <span>2.</span> Background Check:
          </h3>{" "}
          The police department conducts a thorough background check to verify
          the applicant's criminal record and personal details.
        </li>
        <li>
          <h3>
            <span>3.</span> Issuance of PCC:
          </h3>{" "}
          Upon successful verification, the police department issues the PCC
          certifying that the applicant has no criminal history.
        </li>
        <li>
          <h3>
            {" "}
            <span>4.</span>State Home Department Attestation:
          </h3>{" "}
          The issued PCC is attested by the State Home Department to
          authenticate its validity within the state.
        </li>
        <li>
          <h3>
            {" "}
            <span>5.</span> Ministry of External Affairs (MEA) Attestation:
          </h3>{" "}
          The document undergoes attestation by the Ministry of External Affairs
          to confirm its authenticity for international use.
        </li>
        <li>
          <h3>
            {" "}
            <span>6.</span> Embassy Attestation:
          </h3>{" "}
          The final step involves attesting the PCC at the Qatar Embassy in
          India, ensuring recognition and acceptance by Qatari authorities.
        </li>
      </ul>
    </div>
  );
};

export default QatarPccProcedure;
